// 资源类型
export const RESOURCE_TYPE = {
  WEB: 'vehicle_web', // PC
  MP: 'vehicle_mini_program', // 小程序
  PRIVACY: 'vehicle_all', // 脱敏资源
}

const generateGroupName = () => {
  const result = {}
  for (const i in RESOURCE_TYPE) {
    if (Object.prototype.hasOwnProperty.call(RESOURCE_TYPE, i)) {
      result[RESOURCE_TYPE[i]] = {
        businessGroup: RESOURCE_TYPE[i],
        groupName: 'vehicle',
        allVisible: true,
      }
    }
  }
  return result
}

export const RESOURCE_PARAMS = generateGroupName()
